import React from 'react';
import { AngryManIcon, SolutionIcon } from '../../utils/icons';
import '../../styles/components/HomeSection/ProblemSolution.css';

const ProblemSolution: React.FC = () => {
  return (
    <section id="problem-solution" className="problem-solution-section">
      <div className="problem-solution-container">
        <h2 className="problem-solution-title">The Problem We Solve</h2>
        <div className="problem-solution-grid">
          <div className="problem-card">
            <div className="problem-icon">
              <AngryManIcon size={48} className="icon-svg" />
            </div>
            <h3>Parking Jam Frustration</h3>
            <p>Every day, drivers face the frustrating situation of being blocked in parking spots. You need to leave but can't find who's blocking you, leading to delays, missed appointments, and unnecessary stress.</p>
          </div>
          <div className="solution-card">
            <div className="solution-icon">
              <SolutionIcon size={48} className="icon-svg" />
            </div>
            <h3>Our Solution</h3>
            <p>RushHour transforms parking management by connecting drivers through smart notifications. Register your car, report blocking situations, and get instant alerts when you can finally leave. Parking jams become a thing of the past!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
 